import React, { Fragment, useState } from "react"
import {
  Container, Col,
  Card, CardHeader, CardBody, CardFooter,
  FormGroup, FormFeedback, InputGroup, InputGroupAddon, InputGroupText,
  Button,
  Alert
} from 'reactstrap'
import SweetAlert from 'react-bootstrap-sweetalert';

import { Formik, Form, Field } from 'formik';
import { submitSignUp } from '../../redux/actions/authentication'
import { connect, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { signUpValidation } from './Validation'

export default function SignUp(props) {

  const [firstNameFocus, setFirstNameFocus] = useState(false),
  [lastNameFocus, setLastNameFocus] = useState(false),
  [emailFocus, setEmailFocus] = useState(false),
  [phoneFocus, setPhoneFocus] = useState(false),

  [alerts, setAlerts] = useState([]),

  dispatch = useDispatch(),
  history = useHistory(),

  validationSchema = signUpValidation,

  [ showError, setShowError ] = useState({
    visible: false,
    message: '',
    code: ''
  })

  async function signUp(parameters) {

    console.log('parameters: ', parameters)

    const response = await dispatch(
      submitSignUp({
        first_name: parameters.firstName,
        last_name: parameters.lastName,
        email: parameters.email,
        phone: parameters.phone,
        role_id: 2
      })
    )

    const payload = response.payload
    console.log("payload: ", payload)

    if (response.type === "SUBMIT_SIGNUP") {
      history.push("/auth/email")

    } else {
      setShowError({ visible: true,
        message: payload.data.message,
        code: payload.data.code })
    }

  }

  function roleId() {
    const pathname = history.location.pathname

    switch (history.location.pathname) {
      case "auth/signup":
        return 2
      case "signup/teammate":
        return 3
      case "signup/investor":
        return 4
    }
  }

  return (
		<Fragment>
			<div className="content">
				<div className="login-page">
					<Container>
						<Col md="8" lg="6" className="mx-auto">
							{ alerts.map( alert => (
								<Alert color={alert.message_type} key={`login-alert-${alert.id}`}>{alert.message}</Alert>
							) ) }
						</Col>
						<Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
							<Formik
								initialValues={{
                  firstName:'',
                  lastName:'',
									email: '',
                  phone: '',
                  roleId: {roleId},
								}}
								validationSchema={validationSchema}
								onSubmit={values => {
									signUp(values)
								}}
							>
								{ ({values, errors, touched}) => (

									<Form>
										<Card className="card-login card-plain">
											<CardHeader>
												<div className="logo-container mb-2">
													<img src="http://placehold.it/306x57" alt="" />
												</div>
											</CardHeader>
											<CardBody>
												<h5 className="text-white font-weight-bold mb-1">Pitch Pages</h5>
												<p className="text-white">Please sign up.</p>
												<FormGroup>
													<InputGroup
														className={
															"no-border form-control-lg " +
															(emailFocus ? "input-group-focus" : "") +
															(errors.firstName && touched.firstName ? ' has-danger' : '')
														}
													>
														<InputGroupAddon addonType="prepend">
															<InputGroupText>
																<i className="now-ui-icons users_circle-08" />
															</InputGroupText>
														</InputGroupAddon>
														<Field
															name="firstName"
															type="text"
															className="form-control"
															placeholder="First Name"
															onFocus={e => setFirstNameFocus( true )}
															onBlur={e => setFirstNameFocus( false )}
															value={values.firstName}
														/>
													</InputGroup>
													{ errors.firstName && touched.firstName && <FormFeedback>{errors.firstName}</FormFeedback> }
												</FormGroup>
                        <FormGroup>
													<InputGroup
														className={
															"no-border form-control-lg " +
															(emailFocus ? "input-group-focus" : "") +
															(errors.lastName && touched.lastName ? ' has-danger' : '')
														}
													>
														<InputGroupAddon addonType="prepend">
															<InputGroupText>
																<i className="now-ui-icons users_circle-08" />
															</InputGroupText>
														</InputGroupAddon>
														<Field
															name="lastName"
															type="text"
															className="form-control"
															placeholder="Last Name"
															onFocus={e => setLastNameFocus( true )}
															onBlur={e => setLastNameFocus( false )}
															value={values.lastName}
														/>
													</InputGroup>
													{ errors.lastName && touched.lastName && <FormFeedback>{errors.lastName}</FormFeedback> }
												</FormGroup>
                        <FormGroup>
													<InputGroup
														className={
															"no-border form-control-lg " +
															(emailFocus ? "input-group-focus" : "") +
															(errors.email && touched.email ? ' has-danger' : '')
														}
													>
														<InputGroupAddon addonType="prepend">
															<InputGroupText>
																<i className="now-ui-icons users_circle-08" />
															</InputGroupText>
														</InputGroupAddon>
														<Field
															name="email"
															type="text"
															className="form-control"
															placeholder="Email"
															onFocus={e => setEmailFocus( true )}
															onBlur={e => setEmailFocus( false )}
															value={values.email}
														/>
													</InputGroup>
													{ errors.email && touched.email && <FormFeedback>{errors.email}</FormFeedback> }
												</FormGroup>
                        <FormGroup>
													<InputGroup
														className={
															"no-border form-control-lg " +
															(emailFocus ? "input-group-focus" : "") +
															(errors.email && touched.email ? ' has-danger' : '')
														}
													>
														<InputGroupAddon addonType="prepend">
															<InputGroupText>
																<i className="now-ui-icons users_circle-08" />
															</InputGroupText>
														</InputGroupAddon>
														<Field
															name="phone"
															type="text"
															className="form-control"
															placeholder="Phone"
															onFocus={e => setPhoneFocus(true)}
															onBlur={e => setPhoneFocus(false)}
															value={values.phone}
														/>
													</InputGroup>
													{ errors.phone && touched.phone && <FormFeedback>{errors.phone}</FormFeedback> }
												</FormGroup>
											</CardBody>
											<CardFooter>
												<Button
													block
													color="secondary"
													size="lg"
													className="mb-3 btn-round"
													type="submit"
												>
													Submit
												</Button>
												<div className="pull-right">
													<h6>
														<Link to="/auth/forgot-password" className="link footer-link">
															Forgot Password?
														</Link>
													</h6>
												</div>
											</CardFooter>
										</Card>
									</Form>
								)}
							</Formik>
						</Col>
					</Container>
				</div>
			</div>
			<div
				className="full-page-background"
				style={{ backgroundImage: "url(http://placehold.it/2400x800)" }}
			/>
      <SweetAlert
        danger
        title="Error"
        onConfirm={() => setShowError({ visible: false, code: '', message: '' })}
        onCancel={() => setShowError({ visible: false, code: '', message: '' })}
        show={showError.visible}
      >
        <div className="mb-2">
          {showError.message}
        </div>
        <div className="align-left">
          Code: {showError.code}
        </div>
      </SweetAlert>
		</Fragment>
	)
}
